export const ImpersonationStatusChange = {
  Started: 'started',
  Expired: 'expired',
  Ended: 'ended',
} as const;

export type ImpersonationStatusChange = typeof ImpersonationStatusChange[keyof typeof ImpersonationStatusChange];
